import $ from 'jquery'
import ManageTriUrgence from '@/views/parametres/tarif-admissions/param-tri-urgence/manage-tri-urgence'
import store_config from '@/store/mods/parametres/config'

export default {
    name: 'param-tri-urgence',
    components: {
        ManageTriUrgence
    },
    props: [],
    data() {
        return {
            toggler: 0,
            is_loading: true,
            is_empty: false,
            is_error: false,

            liste_tri_urgence: [],

            field: [
				{ key: 'libelle', label: 'Libellé' }, { key: 'code_couleur', label: 'Code couleur' },
                { key: 'description', label: 'Description' }, { key: 'actions', label: 'Action.s' }
			],
			filter: "",
			perPage: -1,
			currentPage: 1,
            selected_tri: {
                niveau_tri_urgence_id: 0,
                libelle: '',
                code_couleur: '#000000',
                description: '',
                ordre: 0,
            }
        }
    },

    computed: {

    },

    mounted() {
        this.getListeTriUrgence()
    },

    methods: {
        addTriUrgence() {
            this.toggler = (this.toggler == 0)?1:0
            this.selected_tri = {
                niveau_tri_urgence_id: 0,
                libelle: '',
                code_couleur: '#000000',
                description: '',
                ordre: 0,
            }

            $('.tri-urgence').modal('show')
        },

        editTriUrgence(data) {
            this.selected_tri = data
            
            this.toggler = (this.toggler == 0)?1:0
            $('.tri-urgence').modal('show')
        },

        setNiveauTriToDelete(data) {
            this.toggler = (this.toggler == 0)?1:0
            this.selected_tri = data
            $('.del-tri-urgence').modal('show')
        },

        getListeTriUrgence() {
            this.is_loading = true

            store_config.getTriUrgence().then((response) => {
                this.liste_tri_urgence = response

                if (response.length == 0) {
                    this.is_empty = true
                } else {
                    this.is_empty = false
                }

                this.is_loading = false
            }).catch(() => {
                this.is_loading = false
                this.is_error = true
            })
        },

        reorderTriUrgence() {
            $('.order-niveau-tri').modal('show')
        }
    }
}